<template>
	<div>		

		
		<v-progress-linear
			color="primary"
			v-show="loading_timeline" 
			indeterminate
		></v-progress-linear>
		
		<timeline 
			ref="timeline" 
			:items="items" 
			:groups="groups" 
			:options="options_timeline"
			:events="['rangechanged', 'touch', 'pinch', 'drag', 'drop']"
			@rangechanged="handleRangeChange"
		></timeline>
		
		<!-- Debug: Mostrar items si no hay timeline -->
		<div v-if="!items || items.length === 0" style="padding: 20px; text-align: center; color: #666;">
			No items to display
		</div>
	</div>
</template>

<script>
import TimelinePlaybackMixin from './TimelinePlayback.js';
import { Timeline } from "vue2vis";
import 'vis-timeline/dist/vis-timeline-graph2d.css';
import './TimelinePlayback.css';

export default {
	components: {
		Timeline
	},
	...TimelinePlaybackMixin
};
</script>
